export const reservationConversations = {
  tabs: {
    calls: "Chamadas",
    web: "Web",
    checkins: "Check-ins",
    charges: "Cobranças",
    notes: "Notas",
  },
  checkinBadge: {
    allCompleted: "Todos os check-ins concluídos",
    manuallyResolved: "Entrega final concluída manualmente por um operador",
    progress: "{done}/{total} check-ins concluídos",
  },
  banners: {
    limitedMode:
      "Esta reserva não está configurada para o fluxo completo. Você só pode usar o WhatsApp e as notas internas.",
    rejectedMode:
      "A solicitação foi recusada. Restam disponíveis apenas o WhatsApp e as notas internas.",
    autoReplying: "O agente está respondendo automaticamente.",
  },
  search: {
    placeholder: "Busque por nome, telefone ou código da reserva...",
  },
  list: {
    emptyTitle: "Ainda não há conversas",
    emptyText:
      "Quando o hóspede escrever ou você enviar uma mensagem, a conversa aparecerá aqui.",
    noResultsTitle: "Nenhuma conversa encontrada",
    noResultsText: "Tente outro nome, telefone ou código da reserva.",
    aiActiveTitle: "Agente de IA ativo",
    markAllRead: "Marcar todas como lidas",
  },
  conversation: {
    windowTimer: "Janela de mensagens: {hours}h restantes",
    copyPortalCopied: "Link copiado",
    copyPortalTooltip: "Copiar link de gestão",
    copiedShort: "Copiado",
    copyLinkShort: "Copiar link",
    dropToAttach: "Solte para anexar os arquivos",
    senderBot: "BOT / EQUIPE",
    senderGuest: "HÓSPEDE",
    imageAlt: "Imagem enviada",
    locationReceived: "Localização recebida",
    viewFile: "Ver arquivo",
    notSent: "Não enviada",
    sending: "Enviando...",
    emptyTitle: "Ainda não há mensagens",
    emptyText:
      "Inicie a conversa com um modelo ou aguarde o hóspede escrever.",
  },
  mode: {
    ai: "IA",
    manual: "Manual",
    agentInactiveTooltip:
      "O Agente de IA não está ativo para esta propriedade. Ative-o nas configurações do anúncio para que responda automaticamente.",
    agentInactiveChip: "Agente de IA inativo",
  },
  composer: {
    predefinedTitle: "Respostas predefinidas",
    predefinedEmpty: "Nenhuma resposta predefinida encontrada",
    attachFile: "Anexar arquivo",
    inputPlaceholder: "Comece com / para selecionar uma resposta predefinida.",
    removeFile: "Remover arquivo",
    fileFallback: "arquivo",
  },
  calls: {
    title: "Chamadas desta reserva",
    none: "Nenhuma chamada vinculada a esta reserva.",
    caller: "Chamador",
    bookedFromCall: "Reservado a partir desta chamada",
    pause: "Pausar",
    play: "Reproduzir",
    downloadMp3: "Baixar MP3",
    noRecording: "Sem gravação",
  },
  ota: {
    noData: "Sem dados da reserva para carregar as mensagens da OTA.",
  },
  checkins: {
    title: "Check-ins da reserva",
  },
  charges: {
    title: "Cobranças da reserva",
    noData: "Sem dados da reserva para carregar as cobranças.",
  },
  notes: {
    title: "Notas internas",
    noData: "Sem dados da reserva para carregar as notas.",
  },
  time: {
    today: "Hoje {time}",
    yesterday: "Ontem {time}",
  },
  guestFallback: "Hóspede",
  webGuestFallback: "Hóspede",
  documentFallback: "Documento",
  location: {
    openInMaps: "Abrir no Google Maps",
    viewCoords: "Ver coordenadas ({lat}, {lng})",
  },
  delivery: {
    read: "Lida",
    delivered: "Entregue",
    queued: "Na fila",
    failed: "Falhou",
    sent: "Enviada",
  },
  errors: {
    genericSendFail: "Não foi possível enviar esta mensagem pelo WhatsApp.",
  },
  failureShort: {
    paymentIssue: "problema de pagamento na conta do WhatsApp",
    cannotReceive: "o número não pode receber WhatsApp",
    downloadFailed: "o WhatsApp não conseguiu baixar o arquivo",
    templateMissingData: "faltam dados do modelo",
    requirementsNotMet: "a mensagem não atende aos requisitos do WhatsApp",
  },
  failureTitle: {
    noWhatsapp: "Sem WhatsApp",
    invalidNumber: "Número inválido",
    notSent: "Não enviada",
  },
  alerts: {
    paymentIssue: "Problema de pagamento no WhatsApp",
    whatsappUnavailable: "WhatsApp indisponível",
    qualityReduced: "Qualidade do número reduzida",
  },
  toast: {
    reactivateNoConv: "Não foi possível identificar a conversa para reativá-la.",
    templateSent: "Modelo enviado com sucesso.",
    reactivateFail: "Não foi possível enviar o modelo de reativação.",
    cannotSendWhatsappTitle: "Não é possível enviar pelo WhatsApp",
    invalidPhoneDetail:
      "O telefone desta reserva ({phone}) não é um número válido. Corrija-o em \"Editar reserva\" para enviar mensagens.",
    noPhoneDetail:
      "Esta reserva não tem telefone. Adicione-o em \"Editar reserva\" para enviar mensagens.",
    sendErrorTitle: "Erro de envio",
    sendErrorDetail: "Não foi possível enviar a mensagem",
    errorTitle: "Erro",
    copyLinkFail: "Não foi possível copiar o link",
    agentInactiveTitle: "Agente de IA inativo",
    agentInactiveDetail:
      "Esta propriedade não tem o Agente de IA ativo. Ative-o nas configurações do anúncio.",
    noConvId: "Não foi possível identificar a conversa",
    modeChangeFail: "Não foi possível alterar o modo do chat",
    agentUnavailableTitle: "Agente de IA indisponível",
  },
};
